import React, { useState, useRef, useEffect } from "react";
import { Radio } from "antd";
import downArrow from "../../assets/images/chevron-up-black.svg";
import sortIconDefault from "../../assets/mobile/mobile-sort-icon.svg";

const SortByDropdown = ({
  sortBy,
  onSortChange,
  onApply,
  filters,
  iconSrc = sortIconDefault,
  iconAlt = "sort",
  isMobile = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [localSortBy, setLocalSortBy] = useState(sortBy || "max_profit");
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleRadioChange = (e) => {
    const newSortBy = e.target.value;
    setLocalSortBy(newSortBy);
    onSortChange(newSortBy);
  };

  const handleApply = () => {
    setIsOpen(false);
    onApply(localSortBy);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const sortOptions = [
    {
      value: "newest_first",
      label: "Newest First",
      subtitle: "",
    },
    {
      value: "max_profit",
      label: "Max Profit",
      subtitle: "",
    },
    {
      value: "risk_reward_high_to_low",
      label: "Risk : Reward",
      subtitle: "(High to low)",
    },
    {
      value: "confidence_high_to_low",
      label: "Confidence %",
      subtitle: "(High to low)",
    },
    {
      value: "duration_low_to_high",
      label: "Duration",
      subtitle: "(Low to High)",
    },
  ];

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <div
        className="flex items-center gap-2 rounded-md cursor-pointer text-sm font-medium text-[#454545] min-w-[40px] min-h-[40px] justify-center transition-all duration-200 p-2 md:border md:border-brand-border md:py-[5px] md:px-2.5 md:hover:border-[#1569AB]"
        onClick={toggleDropdown}
      >
        <div className="md:hidden">
          <img src={iconSrc} alt={iconAlt} className="w-5 h-5" />
        </div>
        <div className="hidden md:flex md:items-center md:gap-2">
          <span className="flex flex-col leading-tight">
            <span>SORT BY</span>
          </span>
          <img
            src={downArrow}
            alt="dropdown arrow"
            className={`w-3 h-3 transition-transform duration-200 ${
              isOpen ? "rotate-180" : ""
            }`}
          />
        </div>
      </div>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-[998] md:hidden"
            onClick={toggleDropdown}
          ></div>
          <div className="fixed top-0 left-0 right-0 w-full mt-0 rounded-none z-[999] max-h-[80vh] overflow-y-auto bg-white border border-[#e0e0e0] shadow-[0px_4px_12px_rgba(0,0,0,0.1)] overflow-hidden md:absolute md:top-[calc(100%+8px)] md:right-0 md:w-[320px] md:max-w-[320px] md:rounded-lg md:z-[1000] md:mt-0 md:h-auto md:max-h-none">
            <div className="text-gray-400 pt-3.5 pb-3.5 pl-3.5 font-semibold text-base border-b border-brand-border font-roboto">
              SORT BY
            </div>
            <div className="py-4">
              <Radio.Group
                value={localSortBy}
                onChange={handleRadioChange}
                className="w-full"
              >
                {sortOptions.map((option) => (
                  <div
                    key={option.value}
                    className="py-2.5 px-6 border-b border-[#ebebeb] m-0 transition-colors duration-200 hover:bg-[#f5f5f5] last:mb-0 last:border-b-0"
                  >
                    <Radio
                      value={option.value}
                      className="w-full flex items-center m-0 p-0"
                    >
                      <span className="text-sm font-normal text-[#333] mr-2 font-roboto">
                        {option.label}
                      </span>
                      {option.subtitle && (
                        <span className="text-xs font-normal text-gray-400 font-roboto">
                          {option.subtitle}
                        </span>
                      )}
                    </Radio>
                  </div>
                ))}
              </Radio.Group>
            </div>

            <div className="border-t border-[#e0e0e0] flex justify-end">
              <button
                className="bg-primary text-white border-none rounded-b-lg py-4 px-4 text-base font-medium cursor-pointer transition-colors duration-200 w-full hover:bg-primary active:bg-primary"
                onClick={handleApply}
              >
                Apply
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SortByDropdown;
